import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./career.module.scss"

import SEO from "../../components/seo"
import LayoutNoForm from "../../components/Layout/LayoutNoForm"
import SecondTitle from "../../components/UI/SecondTitle/SecondTitle"

const careerList = [
	{ title: "career.advantages.list.first.title", content: "career.advantages.list.first.text", },
	{ title: "career.advantages.list.second.title", content: "career.advantages.list.second.text", },
	{ title: "career.advantages.list.third.title", content: "career.advantages.list.third.text", },
	{ title: "career.advantages.list.fourth.title", content: "career.advantages.list.fourth.text", },
]

const Career: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<LayoutNoForm location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "career.seo.description" })}
				title={intl.formatMessage({ id: "career.seo.title" })}
				pathname={location.pathname}
			/>
			<SecondTitle desktopImage="/images/pages-heading/to-future.png" mobileImage="/images/pages-heading/to-future-m.png" title={intl.formatMessage({ id: "career.banner.title" })} position="right center" />
			<div className={styles.career}>
				<section className={styles.intro}>
					<p className={styles.introText}>{intl.formatMessage({ id: "career.banner.text" })}</p>
				</section>
				<section>
					<h2 className={styles.careerSubTitle}>{intl.formatMessage({ id: "career.advantages.title" })}</h2>
					<ul className={styles.careerList}>
						{
							careerList.map((item, index) => (
								<li key={index} className={styles.careerItem}>
									<h3 className={styles.careerTitle}>{intl.formatMessage({ id: item.title })}</h3>
									<p className={styles.careerText}>{intl.formatMessage({ id: item.content })}</p>
								</li>
							))
						}
					</ul>
					<div className={styles.banner}>
						<h2 className={styles.bannerTitle}>{intl.formatMessage({ id: "career.contact.title" })}</h2>
						<p className={styles.bannerText}>{intl.formatMessage({ id: "career.contact.prefix" })} <a className={styles.bannerLink} href="mailto:hr@inventale.com">hr@inventale.com</a>{intl.formatMessage({ id: "career.contact.postfix" })}</p>
					</div>
				</section>
			</div>
		</LayoutNoForm>
	)
}

export default Career;
